<template>
  <el-table :data="tableData"
    stripe
    border
    style="width: 100%"
    class="tabWrap"
    height="100%"
    size="mini"
    :cell-style="cellStyle"
    :header-cell-style="{'background-color': '#F7F7F7'}">
    <el-table-column v-for="(v, i) in tabHead"
      :key="i"
      :prop="v.prop"
      :label="v.label"
      :show-overflow-tooltip='true'
      align="center">
      <template slot-scope="scope">
        <template v-if="scope.row.state && v.label == '状态'">
          <el-tag size="mini"
            :type="
              scope.row.state == '待派单' ||
              scope.row.state == '已关闭'
                ? 'info'
                : scope.row.state == '待处理'
                ? 'warning'
                : scope.row.state == '待重新派单'
                ? 'danger'
                : scope.row.state == '已完成'
                ? 'success'
                : ''
            ">{{ scope.row.state }}</el-tag>
        </template>
        <span v-else>{{ scope.row[v.prop] }}</span>
      </template>
    </el-table-column>
    <el-table-column label="操作"
      align="center"
      width="60"
      v-if="activeName=='工单'">
      <template slot-scope="scope">
        <el-button type="text"
          size="mini"
          @click="detailsProcessing(scope.row)">详情</el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { matchingOrderColor } from "@/assets/js/utils";
export default {
  props: {
    activeName: {
      type: String,
      default: "",
    },
    tabHead: {
      type: Array,
      default: () => [],
    },
    tableData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  methods: {
    cellStyle(row) {
      if (row.column.label === "工单级别") {
        return matchingOrderColor(row.row.level);
      }
    },
    detailsProcessing(row) {
      this.$router.push({
        path: "/worksheets",
        query: { id: row.id },
      });
    },
  },
};
</script>

<style>
</style>